import React, { useState, useEffect } from 'react'
import { Pane, Spinner, Overlay, Text } from "evergreen-ui"

import './Loading.scss';
import './ProgressBar';

import img from '../assets/logo_transparent_background.png';
import spinner from '../assets/transparent_favicon.png';
import { ProgressBar } from 'react-bootstrap';
export let Loading = (props) => {
    const {max, current} = props;
    let progress = (((current/max) * 100)).toFixed(0);
    document.title = "DuraProducts"
    return <>
        {/* <Overlay isShown={true}
        shouldCloseOnClick = {false}> */}
            <Pane elevation={3}
                height="100%"
                className="Loading"
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                backgroundColor="white"
                borderRadius="10px">
                <Pane display={"flex"} flexDirection={"column"} justifyContent={"center"} alignItems={"center"} width={"100%"}>
                    {/* <img src={img} width='50%' /> */}
                    {/* <Spinner />   */}
                    {/* <img src={spinner} width={"100px"} className={"rotate"}/> */}
                    {props.children ? props.children : <h3 flex={2} padding={20}>Loading...</h3>}
                    <Pane border="1px solid black" width="50%" borderRadius="10px">
                        <Pane display="flex" justifyContent="center" alignItems="center" background='#206BE1' borderRadius="10px" transition="width 0.1s"  width={`${progress > 0 ? progress : 0}%`}><Text color="white"><strong>{current> 0 ? progress : 0}%</strong></Text></Pane>
                    </Pane>
                </Pane>
            </Pane >
        {/* </Overlay> */}
    </>
}

